import * as THREE from 'three';

export function createAxes(
  scene: THREE.Scene,
  bbox: THREE.Box3,
  existingAxes: THREE.AxesHelper | null,
): THREE.AxesHelper {
  if (existingAxes) scene.remove(existingAxes);

  const center = bbox.getCenter(new THREE.Vector3());
  const dims = bbox.getSize(new THREE.Vector3());
  const largest = Math.max(dims.x, dims.y, dims.z);

  const axes = new THREE.AxesHelper(largest);
  axes.position.set(center.x, center.y, center.z - dims.z / 2);
  axes.visible = false;
  scene.add(axes);
  return axes;
}
